import { takeEvery } from 'redux-saga'
import { put, call, select } from 'redux-saga/effects'
import { resetSpecificManufacturersAndRestartAppSelector } from 'selectors'
import { RESET_SPECIFIC_MANUFACTURER_AND_RESTART_APP } from 'actions/applicationActionTypes'
import compressProject from 'helpers/projects/compressProject'
import { notifyHoneybadgerAction, setupProjectsAction,
  removeManufacturerSpecificCamerasAction,
  removeManufacturerSpecificAction,
  waitForMapIdleAction } from 'actions/applicationActions'
import { updateUiAction } from 'actions/uiActions'
import clearMapComponents from 'helpers/map/clearMapComponents'

export function * resetSpecificManufacturerAndRestartApp(action) {
  try {
    const { map, currentEntity, cameras, mapLocation, zoom, ui, title,
      createdAt, mapType, floorPlans, markups, offline, active,
      cameraDataFilename, entities } = yield select(resetSpecificManufacturersAndRestartAppSelector)

    window.history.pushState({}, document.title, '/')

    if (offline) {
      const projectToPersist =
        compressProject({ updatedAt: Date.now(), cameras, mapLocation, zoom, ui, title, createdAt,
          mapType, floorPlans, markups, currentEntity, entities })

      yield call(clearMapComponents, { map, cameras })
      yield put(waitForMapIdleAction(map.ref))
      yield put(removeManufacturerSpecificCamerasAction())
      yield put(setupProjectsAction(offline, active, projectToPersist, cameraDataFilename))
    } else {
      yield put(removeManufacturerSpecificCamerasAction())
      yield put(removeManufacturerSpecificAction())
      yield put(updateUiAction({ modal: null }))
    }
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

export function * watchResetSpecificManufacturerAndRestartApp() {
  yield * takeEvery(RESET_SPECIFIC_MANUFACTURER_AND_RESTART_APP, resetSpecificManufacturerAndRestartApp)
}



// WEBPACK FOOTER //
// ./src/sagas/resetSpecificManufacturerAndRestartAppSaga.js